import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  IonCheckbox,
  IonCol,
  IonGrid,
  IonIcon,
  IonInput,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonRow,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { APP_CONFIG } from '@okcargo-apps/shared-infrastructure';
import { CompanyRegistrationUserFormModel } from '../company-registration-forms.model';

const MANDATORY_ERROR_KEY = 'error.mandatory';

@Component({
  selector: 'lib-user-registration-form',
  templateUrl: './user-registration-form.component.html',
  styleUrls: ['./user-registration-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    IonCheckbox,
    IonItem,
    IonItemGroup,
    IonItemDivider,
    IonIcon,
    TranslateModule,
  ],
})
export class UserRegistrationFormComponent {
  private readonly config = inject(APP_CONFIG);

  public form = input.required<FormGroup<CompanyRegistrationUserFormModel>>();

  public readonly legalLinks = {
    termsUrl: this.config.termsUrl,
    privacyUrl: this.config.privacyUrl,
  };

  public getErrorMessage(controlName: keyof CompanyRegistrationUserFormModel): string | null {
    const control = this.form().controls[controlName];
    if (!control || !control.errors) {
      return null;
    }

    const firstErrorKey = Object.keys(control.errors)[0];
    const errorData = control.errors[firstErrorKey];

    if (typeof errorData === 'string') {
      return errorData;
    }
    return errorData?.message || MANDATORY_ERROR_KEY;
  }
}
